module.exports = __webpack_public_path__ + "img/cal-diners-stacked.675deb67.png";